import Cookie from 'universal-cookie';

export const cookie = new Cookie();
